<div class="card bg" [dir]="apiService.currentDirection">
    <div class="container rounded pt-3 card-header" style="background-color:#ffc200; height: 350px;">
        <img [src]="userProfile.profilePic" class="mx-auto d-block rounded-circle" width="150px" height="150px" alt="">
        <br>
        <div class="badge badge-light badge-pill rating" style="width: fit-content ;">
            <ngb-rating [max]="5" [(rate)]="userProfile.technicnianInfo.rate" [readonly]="true">
                
            </ngb-rating>
            <h6><span class="position-absolute badge rounded-pill badge-secondary"> {{userProfile.technicnianInfo.ratingCount}} </span></h6>
        </div>
        <br>
        <h4 class="text-center"> {{userProfile.name}} {{userProfile.family}} </h4>
        <h6 class="text-center"><i [dir]="apiService.currentDirection" class="fa fa-map-marker"></i>
            {{userProfile.city}}، {{userProfile.province}}، {{userProfile.country}} 
        </h6>
    </div>
    <div class="container pt-3" style="background-color:#f5f5f5; height: auto;">        

        <audio class="voice" controls *ngIf="userProfile.voice" [(src)]="userProfile.voice" type="audio/acc">
          </audio>

          <div class="card" style="color: rgb(150, 150, 150);"
            [ngStyle]="{'text-align': this.apiService.currentDirection === 'rtl'? 'right': 'left'}">
            <div class="card-header">
                <h6> {{'Confirmation' | translate}} :</h6>
                
                <p *ngFor="let confirm of userProfile.technicnianInfo.confirmations">
                    <img [src]="confirm.icon" height="30px" width="30px" alt="">
                    {{confirm.name}} </p>
            </div>
        </div>


        <mat-accordion [dir]="apiService.currentDirection" [ngStyle]="{'direction':this.apiService.currentDirection ==='rtl'? 'rtl': 'ltr'}">
            <mat-expansion-panel [ngStyle]="{'text-align': this.apiService.currentDirection === 'rtl'? 'right': 'left'}" [expanded]="true" *ngFor="let skill of userProfile.technicnianInfo.skills">
                <mat-expansion-panel-header [collapsedHeight]="'70px'">
                    <a target="_blank" [href]="['https://web.alobodo.com/requestingDetailsPage?technicianId='+userProfile.id+'&skillId='+skill.id]">
                    <button class="btn btn-warning btn-sm" style="height:fit-content; margin: 10px;">                        
                            {{'Request' | translate}}                                                  
                    </button></a>
                    <mat-panel-title>
                        <img [src]="skill.icon" width="50px" height="50px" alt="">
                        <div class="row col-12 text-justify">
                            <h6 class="display-6 d-flex" style="padding: 10px;">{{skill.name}}</h6>
                        </div>
                        
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-panel-description>
                    <div class="row col-12">
                        <hr>
                        <div class="row col-12">
                            <span><h6> {{'Description' | translate}} : </h6>
                            <p> {{skill.skillBio}} </p></span>
                        </div>
                        <hr>
                        <div class="row col-12">
                            <span><h6 > {{'Tags' | translate}} : </h6>
                            <p *ngFor="let tag of skill.tags" class="badge-outline badge badge-warning" style="margin: 3px;"> {{tag.title}}
                            </p></span>
                        </div>
                        <hr>
                        <div class="row col-12">
                            <span>
                            <h6> {{'Sample' | translate}} :</h6>
                            <img *ngFor="let pic of skill.pictures" [src]="pic.imageMD5" alt="" width="50px" height="50px">
                            </span>
                        </div>
                    </div>


                </mat-panel-description>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>